export default {
  metadata: {
    version: '1.0.0',
    id: 'bottom-navigation-item-1.0.0',
    name: 'JDSBottomNavigationItem'
  },
  hierarchy: {
    container: [
      {
        'jds-icon-container': ['jds-icon']
      },
      'jds-text'
    ]
  },
  base: {
    container: {
      width: '{b_0}',
      'flex-direction': '{b_1}',
      'justify-content': '{b_2}',
      'align-items': '{b_3}',
      gap: '{b_4}',
      opacity: '{b_6}'
    },
    'jds-icon': {
      size: '{icon_5}',
      color: '{icon_15}'
    },
    'jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}'
    },
    'jds-text': {
      'font-family': '{text_167}',
      color: '{text_21}',
      'font-size': '{text_166}',
      'line-height': '{text_168}',
      'letter-spacing': '{text_169}',
      'font-weight': '{text_170}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      'text-align': 'center',
      'max-lines': 1,
      hidden: true,
      maxLines: 1
    }
  },
  variant: {
    showLabel: {
      true: {
        'jds-text': {
          hidden: false
        }
      }
    },
    active: {
      true: {
        'jds-icon': {
          color: '{icon_12}'
        },
        'jds-icon-container': {},
        'jds-text': {
          color: '{text_20}'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{b_5}'
        }
      }
    },
    multiLine: {
      true: {
        'jds-text': {
          'max-lines': 2,
          maxLines: 2
        }
      }
    }
  },
  api: {
    config: {
      showLabel: {
        values: [false, true]
      },
      active: {
        values: [false, true]
      },
      disabled: {
        values: [false, true]
      },
      multiLine: {
        values: [false, true]
      }
    },
    data: {
      'jds-icon': {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      'jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'tab'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'label'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          'aria-selected': {
            name: '_ariaSelected',
            prop: 'active'
          }
        }
      }
    }
  }
};
